import React from 'react';

import { useUserStore } from 'Store/userStore';

import BackDropSpin from 'Components/UI/BackDropSpin';

const LoadingBackDropSpin = () => {
    const loading = useUserStore((state) => state.loading);
    return <>{!!loading && <BackDropSpin />}</>;
};

export default LoadingBackDropSpin;
